import { render, staticRenderFns } from "./vue-tel-input-vuetify.vue?vue&type=template&id=0de1b0ae&"
import script from "./vue-tel-input-vuetify.vue?vue&type=script&lang=js&"
export * from "./vue-tel-input-vuetify.vue?vue&type=script&lang=js&"
import style0 from "./sprite.css?vue&type=style&index=0&lang=css&"
import style1 from "./vue-tel-input-vuetify.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
